import React, { useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FiMail, FiUser, FiLock, FiMap } from 'react-icons/fi';
import { Link, useParams } from 'react-router-dom';


import { MdError } from 'react-icons/md';

import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormHandles } from '@unform/core';
import Input from '../../../../components/Forms/Input';
import Button from '../../../../components/Forms/Button';
import Loader from '../../../../components/Loader';
import MaskedInput from '../../../../components/Forms/MaskedInput';
import { ResponseMessage } from '../../../../components/ResponseMessage';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { Error, Separator, Container, FixedResponse } from './styles';
import SelectSimple from '../../../../components/Forms/SelectSimple';
import Whatsapp from '../../../../components/WhatsAppCompartilhar';

import JsonListMultiple from '../../../../components/Forms/JsonListMultiple';

import api from '../../../../services/api';
import { authTitle, eventName, recaptchaKey, urlWebsite } from '../../../../config';
import getCep from '../../../../services/cep';
import { FaBuilding, FaGenderless, FaIdBadge, FaPhone } from 'react-icons/fa';
import CheckboxInput from '../../../../components/Forms/CheckboxInput';
import { useLanguage } from '../../../../hooks/Language';
import TextareaInput from '../../../../components/Forms/TextareaInput';
import { areas } from './areas';
import CheckboxIncluder from './components/CategoryChange';
import { modalidade } from './modalidade';
import { useToast } from '../../../../hooks/Toast';
import { useModal } from '../../../../hooks/Modal';


interface IRecoverFormData {
  [key: string]: any
}

interface ICaptcha {
  getValue(): string;
}

interface IOption {
  label: string;
  value: string;
  id: string;
}

const AvaliatorSubscription: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);
  const [withPassword, setWithPassword] = useState(true);
  const formRef = useRef<FormHandles>(null);
  const { projectHash } = useParams<Record<string, any>>();
  const [submissionData, setSubmissionData] = useState<Record<string, any>>({});
  const recaptchaRef = useRef(null);
  const { translate } = useLanguage();
  const getCaptchaValue = (elem: ICaptcha): string => {
    return elem.getValue();
  };
  const { addToast } = useToast();
  const [haveAgency, setHaveAgency] = useState('Não');
  const [activeReview, setActiveReview] = useState(false);

  const [category, setCategory] = useState([]);
  const [area, setArea] = useState('');
  const [subarea, setSubarea] = useState('');
  const [countryISO, setCountryISO] = useState('BR');

  const [categoryOptions, setCategoryOptions] = useState<Array<IOption>>([]);
  const [areaOptions, setAreaOptions] = useState<Array<IOption>>([]);
  const [subareaOptions, setSubareaOptions] = useState<Array<IOption>>([]);

  const [initialData, setInitialData] = useState({});







  useEffect(() => {

    const areaOptions: Array<IOption> = [];

    areas.map(a => {
      areaOptions.push({ label: a.title, value: a.title, id: a.title });
    })

    setCategoryOptions(areaOptions);

  }, [])


  const box = (dataInfo, key = '') => {
    if (!dataInfo) {
      return <></>
    }
    return <>
      {dataInfo.map(d => <aside style={{ background: '#eee', padding: '5px', margin: '5px', color: '#333', width: 'auto' }}>{key === 'self' ? d || '' : d?.[key] || ''}</aside>)}
    </>
  }


  const checkCategoria = (category, area) => {

    const categoryList = area.finIndex(a => a.title === category);

    if (!category) {
      addToast({ title: 'Campo categoria de submissão é obrigatório' });
      setLoading(false);
      return;
    }

  }

  const handleNewLogin = async (data: IRecoverFormData) => {

    data.themes = category;
    data.category = data.category_id;


    setLoading(true);





    data.nested_orientation_time = data.orientation_time.reduce((prev, item) => `${prev}, ${item}`, '');


    // data.papers_numbers = data.papers_numbers?.[0] ? data.papers_numbers?.[0] : '';
    data.turno_apresentacao = data.turno_apresentacao?.[0] ? data.turno_apresentacao?.[0] : '';

    try {
      formRef.current?.setErrors({});





      const shape: Record<string, any> = {
        name: Yup.string().required('O campo Nome do autor é obrigatório'),
        document_number: Yup.string().required('O campo CPF é obrigatório'),
        email: Yup.string().required('O campo Email do autor é obrigatório'),
        password: Yup.string().required('O campo senha é obrigatório'),
        //  papers_numbers: Yup.string().required('Especifique o número de trabalhos que deseja avaliar'),
        themes: Yup.string().required('O campo áreas de atuação é obrigatório'),
        //category: Yup.string().required('O campo categoria é obrigatório'),
        is_orientating: Yup.string().required('Informe se você é orientador de alunos dos programas de IC, ITI, PID, Extensão'),

        orientation_time: Yup.string().required('O campo Turno de avaliacao é obrigatório'),
      };

      if (categoryValue === 'Doutorando de Programas de Pós-Graduação de outras Instituições de Ensino Superior') {
        // shape.lattes = Yup.string().required('O Currículo Lattes é obrigatório');
      }





      const schema = Yup.object().shape(shape);

      await schema.validate(data, { abortEarly: false });



      if (!activeReview) {
        setSubmissionData(data);
        setActiveReview(true);
        setLoading(false);
        return;
      }




      const response = await api.post(`/signup-avaliator`, {
        ...data,
        project_id: projectHash

      });

      setSuccess(true);
      setLoading(false);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        if (formRef && formRef.current && formRef.current.setErrors) {
          formRef.current.setErrors(errors);
        }
        setLoading(false);

        const errorsString = Object.keys(errors).reduce(
          (prev: Array<string>, key: string): Array<string> => {
            prev = [...prev, errors[key]];
            return prev;
          },
          [],
        );

        setErrorMessage(errorsString);

        return;
      }

      console.log(err);

      setErrorMessage([
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        'Erro ao gerar seu cadastro',
      ]);
    }
    setLoading(false);
  };

  const [categoryValue, setCategoryValue] = useState('');
  const { addModal } = useModal();

  const getOrientacoes = () => {

    addModal({
      theme: "whiteModal", title: "ORIENTAÇÕES PARA A INSCRIÇÃO DE AVALIADORES", content: <p>



        1.1 Acessar o link para inscrição de avaliadores e preencher as informações solicitadas indicando 1 ou mais categorias em que atua: ensino, pesquisa e extensão e duas ou mais subáreas específicas dentro de cada categoria quando houver e preferência de turno para a participação na banca de apresentação oral dos trabalhos.
        <br /><br />  1.2 Os avaliadores que forem orientadores dos programas de Ensino (PID-UFCSPA) vigência 2022, de Iniciação Científica e Tecnológica da UFCSPA (PIBIC-CNPq, PIBIC-Af-CNPq, PIC-UFCSPA, PROBIC-Fapergs, PROBITI-Fapergs) vigência 2021-2022 e/ou de Extensão (PROBEXT-UFCSPA) vigências 2022 devem inscrever-se em todas as áreas que atuem como orientadores segundo o que determina o Programa ao qual estão vinculados.
        <br /><br />   1.3 A XIV Simpósio Brasileiro de Microbiologia Aplicada ocorrerá de 07 a 09/11/22 de forma presencial, a apresentação oral dos trabalhos ocorrerá nos turnos manhã (9-11:30h), tarde (14-16:30h) e noite (18:30-21h). Os professores avaliadores devem indicar pelo menos dois turnos para avaliação dos trabalhos da Mostra nos dias 07, 08 e 09/11/22.
        <br /><br />   1.4 Os avaliadores terão acesso aos resumos com antecedência.
        <br /><br />   1.5 Durante a sessão de apresentação os avaliadores deverão avaliar o resumo e a apresentação oral segundo os seguintes parâmetros: adequação às normas de elaboração do resumo; título adequado ao objeto de trabalho; delimitação dos objetivos; adequação da metodologia aos objetivos propostos; adequação dos resultados obtidos/esperados aos objetivos propostos) e apresentação oral (postura, linguagem e qualidade dos slides; clareza e objetividade; domínio do assunto; cumprimento do tempo).

      </p>
    })


  }

  const [ended, setEnded] = useState(true);

  if (ended) {
    return <Container style={{ minHeight: '60vh', display: 'flex', alignItems: 'center' }}>

      <h2 style={{ background: 'rgb(0,14,64)', color: '#fff', padding: '15px', marginBottom: '15px' }}>Inscrições de avaliadores encerrada</h2>
      <Link to="/app/microbiologia-2022/login-avaliador"><Button>Logar como avaliador</Button></Link>
    </Container>
  }

  return (
    <>
      {loading === true && (
        <Loader message="Preparando seu cadastro..." position="fixed" />
      )}

      <aside style={{
        width: '100%',
        padding: '20px'
      }}>
        {success ? (<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <ResponseMessage
            active
            type="success"
            title="Sucesso"
            description={
              <><p>
                Cadastro realizado com sucesso!
                <br />


              </p>
                <aside style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                  <Link to="/app/microbiologia-2022/login-avaliador" style={{ width: 'auto' }}><button className="defaultButton">Acessar área do avaliador</button></Link>
                </aside></>
            }
          /></div>
        ) : (<Container>
          <Form ref={formRef} initialData={initialData} onSubmit={handleNewLogin} style={{ maxWidth: '800px' }}>
            <h1>Cadastro de avaliadores</h1>
            <p>Cadastro para avaliador dos resumos submetidos na {eventName}, cada resumo terá até 2000 caracteres.</p>

            <button className="defaultButton" onClick={() => getOrientacoes()}>Orientações de inscrição</button>
            <Separator>


              <label>1.1 - Dados do Avaliador</label>
              <Input name="name" placeholder="Nome Completo" />
              <MaskedInput mask="999.999.999-99" name="document_number" placeholder="CPF" />
            </Separator>

            <Separator>
              <label>1.2 - Dados do Acesso</label>
              <Input name="email" placeholder="Email" />
              <Input type="password" name="password" placeholder="Cadastre sua senha de acesso" />
            </Separator>

            <Separator>
              <label>1.3 - É orientador de alunos dos programas de IC, ITI, PID, Extensão?</label>

              <SelectSimple name="is_orientating" label="" options={[
                { value: 'Sim', label: 'Sim' },
                { value: 'Não', label: 'Não' },
              ]} />

            </Separator>

            <Separator>
              <label>1.4 - Categoria</label>
              <SelectSimple name="category_id" label="" setCallback={(value) => { setCategoryValue(value) }} options={[
                { value: 'Professor da UFCSPA', label: 'Professor da UFCSPA' },
                { value: 'Doutorando ou pós-doc dos Programas de Pós - Graduação da UFCSPA', label: 'Doutorando ou pós-doc dos Programas de Pós - Graduação da UFCSPA' },
                { value: 'Professor doutor de outras Instituições de Ensino Superior', label: 'Professor doutor de outras Instituições de Ensino Superior' },
                { value: 'Doutorando de Programas de Pós-Graduação de outras Instituições de Ensino Superior', label: 'Doutorando de Programas de Pós-Graduação de outras Instituições de Ensino Superior' },
              ]} />
              {categoryValue === 'Doutorando de Programas de Pós-Graduação de outras Instituições de Ensino Superior' && <Input name="lattes" placeholder="Link do Currículo Lattes" />}
            </Separator>








            <Separator>
              <label>2 - Área de atuação</label>

              <p style={{ color: '#fff' }}>Área de atuação dentro das categorias de ensino, pesquisa e extensão (indicar 2 ou mais subáreas quando houver). <br /> O professor que atua em mais de uma categoria deve indicar as subáreas em todas as categorias que atua.</p>

              <CheckboxIncluder highlight={true} category={category} area={area} subarea={subarea} setSubarea={(value) => setSubarea(value)} setArea={(value) => setArea(value)} setCategory={(value) => setCategory(value)} name="category" options={areas} placeholder="Categorias" />

            </Separator>


            {/*  <Separator>
              <label>3 - Número de resumos para avaliação</label>
              <CheckboxInput unique name="papers_numbers" options={
                [
                  { value : '5 a 8', id:'5 a 8', label: '5 a 8'},
                  { value : '9 a 11', id:'9 a 11', label: '9 a 11'},
                  { value : '12 a 14', id:'12 a 14', label: '12 a 14'}
                ]
              } placeholder="" />

            </Separator> */}


            <Separator>
              <label>3 - Turno disponível para banca de avaliação (indicar 2 ou mais turnos)</label>
              <p style={{ color: '#333' }}>Apresentação dos trabalhos da Mostra de Ensino, Pesquisa e Extensão será nos dias 7, 8 e 9/11/22 nos três turnos.</p>
              (	)


              <CheckboxInput name="orientation_time" options={


                [

                  { value: 'segunda-feira 07/11/22 – tarde', id: 'segunda-feira 07/11/22 – tarde', label: 'segunda-feira 07/11/22 – tarde' },
                  { value: 'segunda-feira 07/11/22 – noite', id: 'segunda-feira 07/11/22 – noite', label: 'segunda-feira 07/11/22 – noite' },
                  { value: 'terça-feira 08/11/22 – manhã', id: 'terça-feira 08/11/22 – manhã', label: 'terça-feira 08/11/22 – manhã' },
                  { value: 'terça-feira 08/11/22 – tarde', id: 'terça-feira 08/11/22 – tarde', label: 'terça-feira 08/11/22 – tarde' },
                  { value: 'terça-feira 08/11/22 – noite', id: 'terça-feira 08/11/22 – noite', label: 'terça-feira 08/11/22 – noite' },
                  { value: 'quarta-feira 09/11/22 – manhã', id: 'quarta-feira 09/11/22 – manhã', label: 'quarta-feira 09/11/22 – manhã' },
                  { value: 'quarta-feira 09/11/22 – tarde', id: 'quarta-feira 09/11/22 – tarde', label: 'quarta-feira 09/11/22 – tarde' },
                ]
              } placeholder="" />

            </Separator>



            {errorMessage && (
              <Error>
                {errorMessage.map((item, index) => (
                  <div key={`error${index}`}>
                    <MdError />
                    {item}
                  </div>
                ))}
              </Error>
            )}

            <aside style={{ display: 'flex', justifyContent: 'center' }}>
              <Button style={{ width: '100%' }} type="submit">
                Enviar
              </Button>
            </aside>

            <FixedResponse style={{ display: activeReview ? 'flex' : 'none' }}>
              <div>
                <h1>Revisão de dados</h1>

                <h2>1 - Dados do Avaliador</h2>
                <strong>Nome completo</strong><p>{submissionData?.name}</p>
                <strong>CPF</strong><p>{submissionData?.document_number}</p>


                <h2>1.2 - Dados de acesso</h2>
                <strong>Email</strong><p>{submissionData?.email}</p>

                <h2>1.3 - Informações adicionais</h2>
                <strong>É orientador de alunos dos programas de IC, ITI, PID, Extensão?</strong><p>{submissionData?.is_orientating}</p>
                {/*   <strong>Link do Currículo Lattes</strong><p>{submissionData?.lattes}</p> */}

                <h2>1.4 - Categoria</h2>
                <strong>Categoria</strong><p>{submissionData?.category}</p>
                {submissionData?.category === 'Doutorando de Programas de Pós-Graduação de outras Instituições de Ensino Superior' && <><strong>Link do Currículo Lattes</strong><p>{submissionData?.lattes}</p></>}



                <h2>2 - Área de atuação</h2>
                {submissionData?.themes && submissionData?.themes.map(d => <aside style={{ background: '#eee', padding: '5px', margin: '5px', color: '#333', width: 'auto' }}>{d?.subarea ? `${d.category} > ${d.area} > ${d.subarea}` : `${d.category} > ${d.area}`}</aside>)}

                {/*      <h2>3 - Número de resumos para avaliação</h2>

              <strong>Quantidade</strong><p>{submissionData?.paper_numbers}</p> */}


                <h2>3 - Turno disponível para banca de avaliação (indicar 2 ou mais turnos)</h2>

                <strong>Datas</strong><p>{box(submissionData?.orientation_time, 'self')}</p>



                <button className="defaultButtonReverse" type="button" onClick={() => setActiveReview(false)}>Editar</button>
                <button className="defaultButton" type="submit">Enviar</button>
              </div>

            </FixedResponse>
          </Form>
        </Container>
        )}
      </aside>


    </>
  );
};

export default AvaliatorSubscription;

